export interface IByggKunde {
    bygningsNummer: string;
    kundeNummer: string;
    kundeNavn: string;
    aktive: number;
    fremtidige: number;
    inaktive: number;
    isHandelKunde: boolean;
    isNaeringKunde: boolean;
    isSuperOfficeKunde: boolean;
    sistAktivDato?: string;
    velkomstmeldingSendtDato?: string;
}

export class ByggKunde implements IByggKunde {
    public static parseObject(obj: IByggKunde): ByggKunde {
        try {
            return new ByggKunde(obj);
        } catch (e) {
            throw new Error('Not able to parse object');
        }
    }

    public bygningsNummer: IByggKunde['bygningsNummer'];
    public kundeNummer: IByggKunde['kundeNummer'];
    public kundeNavn: IByggKunde['kundeNavn'];
    public aktive: IByggKunde['aktive'];
    public fremtidige: IByggKunde['fremtidige'];
    public inaktive: IByggKunde['inaktive'];
    public isHandelKunde: IByggKunde['isHandelKunde'];
    public isNaeringKunde: IByggKunde['isNaeringKunde'];
    public isSuperOfficeKunde: IByggKunde['isSuperOfficeKunde'];
    public velkomstmeldingSendtDato: IByggKunde['velkomstmeldingSendtDato'];
    public sistAktivDato: IByggKunde['sistAktivDato'];

    public constructor(params: IByggKunde) {
        Object.assign(this, params);
    }
}
